import axiosClient from './axiosClient'

const companyApi = {
  update: (body) => {
    const url = `/company/update-count`
    return axiosClient.put(url, body)
  },
}

export default companyApi
